import { createMegTemplateApi } from "@org-avp/avp-avengers-megtemplate-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const defaultPageSize = 5_000;
const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_QA_SERVICE_BASE_URL,
  prepareHeaders,
};

export const megTemplateApi: ReturnType<typeof createMegTemplateApi> = createMegTemplateApi({
  baseQueryArgs,
  pageSize: defaultPageSize,
});
